var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionIcon = function (props) { return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M12.2 16.9C12.7796 16.9 13.25 17.3704 13.25 17.95C13.25 18.5296 12.7796 19 12.2 19C11.6204 19 11.15 18.5296 11.15 17.95C11.15 17.3704 11.6204 16.9 12.2 16.9ZM12.2 5C14.5198 5 16.4 6.8802 16.4 9.2C16.4 10.7155 15.8729 11.503 14.5282 12.6461C13.1793 13.792 12.9 14.3079 12.9 15.5H11.5C11.5 13.7682 12.0509 12.9135 13.6217 11.5793C14.6836 10.677 15 10.2038 15 9.2C15 7.653 13.747 6.4 12.2 6.4C10.653 6.4 9.4 7.653 9.4 9.2V9.9H8V9.2C8 6.8802 9.8802 5 12.2 5Z", fill: "currentColor" }) }))); };
